import { render, staticRenderFns } from "./BillTickView.vue?vue&type=template&id=3164fe26&scoped=true"
import script from "./BillTickView.vue?vue&type=script&lang=js"
export * from "./BillTickView.vue?vue&type=script&lang=js"
import style0 from "./BillTickView.vue?vue&type=style&index=0&id=3164fe26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164fe26",
  null
  
)

export default component.exports